import { Locale } from '../enums';

export const CurrencyCode = {
  Dollars: 'USD',
  CanadianDollars: 'CAD',
};

const DEFAULT_OPTIONS = {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
};

const FormatStyle = {
  Currency: 'currency',
};

class NumberFormat {
  static format(number, options = {}, locale = Locale.EnCA) {
    const mergedOptions = { ...DEFAULT_OPTIONS, ...options };

    return new Intl.NumberFormat(locale, mergedOptions).format(number);
  }

  static formatCurrency(number, currencyCode = CurrencyCode.CanadianDollars, locale) {
    return this.format(number, {
      style: FormatStyle.Currency,
      currency: currencyCode,
      locale,
    });
  }

  static formatPercentage(decimalPercentage, numberOfDecimalPlaces = 0) {
    const percentage = (decimalPercentage * 100).toFixed(numberOfDecimalPlaces);

    return `${percentage}%`;
  }
}

export default NumberFormat;
